// import {
//   DECIMAL_PRECISION_STABLE_COIN,
//   DECIMAL_COEFFICIENT_STABLE_COIN,
//   DECIMAL_COEFFICIENT_UNSTABLE_COIN,
//   DECIMAL_PRECISION_UNSTABLE_COIN,
// } from '@libs/backend-common';
// TODO: tmp fix
export const formatPrice = (price) => {
    const numericPrice = typeof price === 'number' ? price : parseFloat(price);
    if (numericPrice < 1000)
        return numericPrice;
    const roundedPrice = Math.max(parseFloat(numericPrice.toFixed(2)), numericPrice);
    return roundedPrice.toLocaleString('en-US', { minimumFractionDigits: 2 });
};
export const formatBalance = (amount, isCrypto) => {
    if (typeof amount === 'undefined') {
        return '0';
    }
    else if (typeof amount === 'string') {
        amount = +amount;
    }
    return parseFloat(amount.toFixed(isCrypto ? 4 : 2)).toLocaleString('en-US', {
        minimumFractionDigits: isCrypto ? 4 : 2,
    });
    // const roundingPrecision = isCrypto
    //   ? DECIMAL_PRECISION_UNSTABLE_COIN
    //   : DECIMAL_PRECISION_STABLE_COIN;
    // const roundingCoefficient = isCrypto
    //   ? DECIMAL_COEFFICIENT_UNSTABLE_COIN
    //   : DECIMAL_COEFFICIENT_STABLE_COIN;
    // const formattedAmount = (
    //   Math.floor(amount * roundingCoefficient) / roundingCoefficient
    // ).toLocaleString('en-US', { minimumFractionDigits: roundingPrecision });
    // return formattedAmount;
};
//# sourceMappingURL=balance.js.map